webpackJsonp([1],{

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(331);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _VueChartJS = __webpack_require__(311);

var _VueChartJS2 = _interopRequireDefault(_VueChartJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '*',
    name: 'VueChartJS',
    component: _VueChartJS2.default
  }]
});

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(326),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(333)));

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(335)));

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(336)));

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(341)));

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sHeader = __webpack_require__(313);

var _sHeader2 = _interopRequireDefault(_sHeader);

var _sFooter = __webpack_require__(312);

var _sFooter2 = _interopRequireDefault(_sFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    sHeader: _sHeader2.default, sFooter: _sFooter2.default
  },
  data: function data() {
    return {
      is_loaded: false
    };
  },

  methods: {
    pageLoader: function pageLoader(status) {
      this.is_loaded = true;
    }
  }

};

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'info',
  data: function data() {
    return {
      text: ''
    };
  },

  props: {
    fetchData: {
      type: Object,
      default: function _default() {
        return [];
      }
    }
  },
  mounted: function mounted() {
    this.text = this.htmlDecode(this.fetchData['about']['text']);
  },
  methods: {
    htmlDecode: function htmlDecode(input) {
      var str = String(input).replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#039;/g, "'");
      var txt = document.createElement("textarea");
      txt.innerHTML = str;
      return txt.value;
    }
  }
};

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__(301);

exports.default = _vueChartjs.Line.extend({
  data: function data() {
    return {
      datacollection: {
        datasets: [{
          backgroundColor: 'rgba(255, 255, 255, 0.15)',
          pointBackgroundColor: 'white',
          pointBorderColor: '#fff',
          pointRadius: 4,
          pointHoverRadius: 6,
          pointHitRadius: 7,
          pointBorderWidth: 2,
          borderColor: '#65f289'
        }]
      },
      options: {
        tooltips: {
          backgroundColor: '#FFF',
          titleFontSize: 16,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 16,
          displayColors: false
        },
        scales: {
          yAxes: [{
            ticks: {
              fontColor: '#fff',
              fontSize: 16,
              autoSkip: true,
              maxTicksLimit: 10,
              padding: 25
            },
            gridLines: {
              display: true,
              color: 'rgba(255,255,255,0.15)',
              drawBorder: false,
              zeroLineColor: 'rgba(255,255,255,0.15)',
              tickMarkLength: -5,
              lineWidth: 1
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#fff',
              fontSize: 16,
              autoSkip: true,
              maxTicksLimit: 7,
              maxRotation: 0
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },

  props: {
    fetchData: {
      type: Object,
      default: function _default() {
        return [];
      }
    },
    chartPeriod: {
      type: String,
      required: true
    }

  },
  watch: {
    chartPeriod: function chartPeriod(val) {
      this._chart.destroy();
      this.createChart(val);
    },
    fetchData: function fetchData(val) {
      this._chart.destroy();
      this.createChart('day');
    }
  },
  mounted: function mounted() {
    this.createChart(this.chartPeriod);
  },

  methods: {
    createChart: function createChart(val) {
      this.getChart(val);
      this.renderChart(this.datacollection, this.options);
    },
    getChart: function getChart(arg) {
      this.getLabels(arg);
      this.getData(arg);
    },
    getLabels: function getLabels(arg) {
      var labels = void 0;
      if (arg === 'day') {
        if (this.fetchData['day']) {
          labels = this.fetchData['day'].map(function (num, index, arr) {
            var h = new Date(num.timestamp * 1000).getHours();
            var m = new Date(num.timestamp * 1000).getMinutes();
            h = h < 10 ? '0' + h : h;
            m = m < 10 ? '0' + m : m;
            return h + ':' + m;
          });
        }
      }
      if (arg === 'week') {
        var days = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
        labels = this.fetchData['week'].map(function (num, index, arr) {
          var n = new Date(num.timestamp * 1000).getDay();
          return days[n];
        });
      }
      this.datacollection.labels = labels;
    },
    getData: function getData(arg) {
      var data = void 0;
      if (arg === 'day') {
        if (this.fetchData['day']) {
          data = this.fetchData['day'].map(function (num, index, arr) {
            var rounded = function rounded(number) {
              return +number.toFixed(2);
            };
            return rounded(num.particulate_matter);
          });
        }
      }
      if (arg === 'week') {
        data = this.fetchData['week'].map(function (num, index, arr) {
          var rounded = function rounded(number) {
            return +number.toFixed(2);
          };
          return rounded(num.particulate_matter);
        });
      }
      this.datacollection['datasets'][0].data = data;
    }
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LineChart = __webpack_require__(310);

var _LineChart2 = _interopRequireDefault(_LineChart);

var _Info = __webpack_require__(309);

var _Info2 = _interopRequireDefault(_Info);

var _fullPage = __webpack_require__(314);

var _fullPage2 = _interopRequireDefault(_fullPage);

var _fullPageMixin = __webpack_require__(307);

var _fullPageMixin2 = _interopRequireDefault(_fullPageMixin);

var _jquery = __webpack_require__(17);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'VueChartJS',
  mixins: [_fullPageMixin2.default],
  components: {
    LineChart: _LineChart2.default, Info: _Info2.default, FullPage: _fullPage2.default
  },
  data: function data() {
    return {
      fetchData: false,
      chartPeriod: 'day',
      chartTitle: 'Твердые частицы',
      chartAddress: '',
      chartValue: '',
      infoTitle: '',
      infoDesc: '',
      infoHumidity: '',
      infoTemp: '',
      markers: [],
      activeLink: 1,
      infoStyle: {
        backgroundColor: ''
      },
      options: {
        afterLoad: this.afterLoad,
        scrollBar: false,
        navigation: false,
        css3: true,
        anchors: ['diagram', 'map', 'info']
      }
    };
  },
  created: function created() {
    this.getData(42.874602, 74.609141);
  },

  methods: {
    afterLoad: function afterLoad() {},

    changePeriod: function changePeriod(val, active) {
      (0, _jquery2.default)('.custom-select__item').removeClass('customSelecActive');
      this.chartPeriod = val;

      this.activeLink = active;
    },
    buildMap: function buildMap(pos) {
      this.chartPeriod = 'day';
      this.activeLink = 1;
      this.getData(pos.lat, pos.lng);
      if ((0, _jquery2.default)(window).width() > 995 && (0, _jquery2.default)(window).height() > 850) {
        this.moveSectionUp(1);
      } else {
        (0, _jquery2.default)('html,body').animate({
          scrollTop: (0, _jquery2.default)('.chart').offset().top
        });
      }
    },
    createMarker: function createMarker(color, value) {
      var template = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 104 145.29"><defs><style>.cls-1{fill:{{ color }};}.cls-2{opacity:0.15;}.cls-2,.cls-3{font-size:30.95px;font-family:SegoeUI-Semilight, Segoe UI;text-align:center;margin-left:10px;}.cls-3{fill:#fff;}</style><linearGradient id="Безымянный_градиент_8" x1="52" y1="145.29" x2="52" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f15a24"/><stop offset="1" stop-color="#f18a24"/></linearGradient></defs><title>ic_map.marker</title><g id="Слой_2" data-name="Слой 2"><g id="Слой_1-2" data-name="Слой 1"><path class="cls-1" d="M104,52c0,28.72-52,93.29-52,93.29S0,80.72,0,52a52,52,0,0,1,104,0Z"/><text xmlns="http://www.w3.org/2000/svg" y="58">\n' + '    <tspan x="49%" class="cls-3" text-anchor="middle">{{ value }}</tspan>\n' + '    \n' + '  </text></g></g></svg>'].join('\n');
      return template.replace('{{ color }}', color).replace('{{ value }}', value);
    },
    getData: function getData(latitude, longitude) {
      var _this = this;

      var self = this;
      var url = 'http://movegreen.kg/api/json.php?latitude=' + latitude + '&longitude=' + longitude;
      this.$http.get(url, {
        method: 'GET'
      }).then(function (response) {
        self.fetchData = response.data.data;
        if (self.fetchData) {
          _this.$emit('pageStatus', true);
        }
        self.chartAddress = response.data.data.address;
        self.chartValue = response.data.data.current.particulate_matter;
        self.infoTitle = response.data.data.status_title;
        self.infoDesc = response.data.data.status_text;
        self.infoStyle.backgroundColor = response.data.data.status_color;
        self.infoTemp = response.data.data.current.temperature;
        self.infoHumidity = response.data.data.current.humidity;
        response.data.data.points.forEach(function (element) {
          self.markers.push({
            position: { lat: parseFloat(element.latitude), lng: parseFloat(element.longitude) },
            icon: {
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(unescape(encodeURIComponent(self.createMarker(element.color, element.particulate_matter)))),
              scaledSize: { width: 50, height: 70, f: 'px', b: 'px' }
            }
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'sFooter'
};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'sHeader'
};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(176);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(172);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(6);

__webpack_require__(175);

var _axios = __webpack_require__(171);

var _axios2 = _interopRequireDefault(_axios);

var _vue2GoogleMaps = __webpack_require__(177);

var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);

__webpack_require__(174);

__webpack_require__(173);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBiEZKw7333oZoTvRpoyy2Ynmwl4RADpHY',
    libraries: 'places'
  }
});
_vue2.default.prototype.$http = _axios2.default;
_vue2.default.use(window.VueCharts);

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 42,
	"./af.js": 42,
	"./ar": 49,
	"./ar-dz": 43,
	"./ar-dz.js": 43,
	"./ar-kw": 44,
	"./ar-kw.js": 44,
	"./ar-ly": 45,
	"./ar-ly.js": 45,
	"./ar-ma": 46,
	"./ar-ma.js": 46,
	"./ar-sa": 47,
	"./ar-sa.js": 47,
	"./ar-tn": 48,
	"./ar-tn.js": 48,
	"./ar.js": 49,
	"./az": 50,
	"./az.js": 50,
	"./be": 51,
	"./be.js": 51,
	"./bg": 52,
	"./bg.js": 52,
	"./bm": 53,
	"./bm.js": 53,
	"./bn": 54,
	"./bn.js": 54,
	"./bo": 55,
	"./bo.js": 55,
	"./br": 56,
	"./br.js": 56,
	"./bs": 57,
	"./bs.js": 57,
	"./ca": 58,
	"./ca.js": 58,
	"./cs": 59,
	"./cs.js": 59,
	"./cv": 60,
	"./cv.js": 60,
	"./cy": 61,
	"./cy.js": 61,
	"./da": 62,
	"./da.js": 62,
	"./de": 65,
	"./de-at": 63,
	"./de-at.js": 63,
	"./de-ch": 64,
	"./de-ch.js": 64,
	"./de.js": 65,
	"./dv": 66,
	"./dv.js": 66,
	"./el": 67,
	"./el.js": 67,
	"./en-au": 68,
	"./en-au.js": 68,
	"./en-ca": 69,
	"./en-ca.js": 69,
	"./en-gb": 70,
	"./en-gb.js": 70,
	"./en-ie": 71,
	"./en-ie.js": 71,
	"./en-il": 72,
	"./en-il.js": 72,
	"./en-nz": 73,
	"./en-nz.js": 73,
	"./eo": 74,
	"./eo.js": 74,
	"./es": 77,
	"./es-do": 75,
	"./es-do.js": 75,
	"./es-us": 76,
	"./es-us.js": 76,
	"./es.js": 77,
	"./et": 78,
	"./et.js": 78,
	"./eu": 79,
	"./eu.js": 79,
	"./fa": 80,
	"./fa.js": 80,
	"./fi": 81,
	"./fi.js": 81,
	"./fo": 82,
	"./fo.js": 82,
	"./fr": 85,
	"./fr-ca": 83,
	"./fr-ca.js": 83,
	"./fr-ch": 84,
	"./fr-ch.js": 84,
	"./fr.js": 85,
	"./fy": 86,
	"./fy.js": 86,
	"./gd": 87,
	"./gd.js": 87,
	"./gl": 88,
	"./gl.js": 88,
	"./gom-latn": 89,
	"./gom-latn.js": 89,
	"./gu": 90,
	"./gu.js": 90,
	"./he": 91,
	"./he.js": 91,
	"./hi": 92,
	"./hi.js": 92,
	"./hr": 93,
	"./hr.js": 93,
	"./hu": 94,
	"./hu.js": 94,
	"./hy-am": 95,
	"./hy-am.js": 95,
	"./id": 96,
	"./id.js": 96,
	"./is": 97,
	"./is.js": 97,
	"./it": 98,
	"./it.js": 98,
	"./ja": 99,
	"./ja.js": 99,
	"./jv": 100,
	"./jv.js": 100,
	"./ka": 101,
	"./ka.js": 101,
	"./kk": 102,
	"./kk.js": 102,
	"./km": 103,
	"./km.js": 103,
	"./kn": 104,
	"./kn.js": 104,
	"./ko": 105,
	"./ko.js": 105,
	"./ky": 106,
	"./ky.js": 106,
	"./lb": 107,
	"./lb.js": 107,
	"./lo": 108,
	"./lo.js": 108,
	"./lt": 109,
	"./lt.js": 109,
	"./lv": 110,
	"./lv.js": 110,
	"./me": 111,
	"./me.js": 111,
	"./mi": 112,
	"./mi.js": 112,
	"./mk": 113,
	"./mk.js": 113,
	"./ml": 114,
	"./ml.js": 114,
	"./mn": 115,
	"./mn.js": 115,
	"./mr": 116,
	"./mr.js": 116,
	"./ms": 118,
	"./ms-my": 117,
	"./ms-my.js": 117,
	"./ms.js": 118,
	"./mt": 119,
	"./mt.js": 119,
	"./my": 120,
	"./my.js": 120,
	"./nb": 121,
	"./nb.js": 121,
	"./ne": 122,
	"./ne.js": 122,
	"./nl": 124,
	"./nl-be": 123,
	"./nl-be.js": 123,
	"./nl.js": 124,
	"./nn": 125,
	"./nn.js": 125,
	"./pa-in": 126,
	"./pa-in.js": 126,
	"./pl": 127,
	"./pl.js": 127,
	"./pt": 129,
	"./pt-br": 128,
	"./pt-br.js": 128,
	"./pt.js": 129,
	"./ro": 130,
	"./ro.js": 130,
	"./ru": 131,
	"./ru.js": 131,
	"./sd": 132,
	"./sd.js": 132,
	"./se": 133,
	"./se.js": 133,
	"./si": 134,
	"./si.js": 134,
	"./sk": 135,
	"./sk.js": 135,
	"./sl": 136,
	"./sl.js": 136,
	"./sq": 137,
	"./sq.js": 137,
	"./sr": 139,
	"./sr-cyrl": 138,
	"./sr-cyrl.js": 138,
	"./sr.js": 139,
	"./ss": 140,
	"./ss.js": 140,
	"./sv": 141,
	"./sv.js": 141,
	"./sw": 142,
	"./sw.js": 142,
	"./ta": 143,
	"./ta.js": 143,
	"./te": 144,
	"./te.js": 144,
	"./tet": 145,
	"./tet.js": 145,
	"./tg": 146,
	"./tg.js": 146,
	"./th": 147,
	"./th.js": 147,
	"./tl-ph": 148,
	"./tl-ph.js": 148,
	"./tlh": 149,
	"./tlh.js": 149,
	"./tr": 150,
	"./tr.js": 150,
	"./tzl": 151,
	"./tzl.js": 151,
	"./tzm": 153,
	"./tzm-latn": 152,
	"./tzm-latn.js": 152,
	"./tzm.js": 153,
	"./ug-cn": 154,
	"./ug-cn.js": 154,
	"./uk": 155,
	"./uk.js": 155,
	"./ur": 156,
	"./ur.js": 156,
	"./uz": 158,
	"./uz-latn": 157,
	"./uz-latn.js": 157,
	"./uz.js": 158,
	"./vi": 159,
	"./vi.js": 159,
	"./x-pseudo": 160,
	"./x-pseudo.js": 160,
	"./yo": 161,
	"./yo.js": 161,
	"./zh-cn": 162,
	"./zh-cn.js": 162,
	"./zh-hk": 163,
	"./zh-hk.js": 163,
	"./zh-tw": 164,
	"./zh-tw.js": 164
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 288;

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/an_loader.584b607.gif";

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

module.exports = {"_args":[[{"raw":"vue-chartjs@^2.6.3","scope":null,"escapedName":"vue-chartjs","name":"vue-chartjs","rawSpec":"^2.6.3","spec":">=2.6.3 <3.0.0","type":"range"},"D:\\data\\front\\chart\\vue-charts"]],"_from":"vue-chartjs@>=2.6.3 <3.0.0","_id":"vue-chartjs@2.8.7","_inCache":true,"_location":"/vue-chartjs","_nodeVersion":"8.5.0","_npmOperationalInternal":{"host":"s3://npm-registry-packages","tmp":"tmp/vue-chartjs-2.8.7.tgz_1505561838079_0.5062592723406851"},"_npmUser":{"name":"apertureless","email":"juszczak.j@googlemail.com"},"_npmVersion":"5.4.2","_phantomChildren":{},"_requested":{"raw":"vue-chartjs@^2.6.3","scope":null,"escapedName":"vue-chartjs","name":"vue-chartjs","rawSpec":"^2.6.3","spec":">=2.6.3 <3.0.0","type":"range"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_shasum":"bcd1cda1a1ef8ed80581638a02cf88182d437d09","_shrinkwrap":null,"_spec":"vue-chartjs@^2.6.3","_where":"D:\\data\\front\\chart\\vue-charts","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"directories":{},"dist":{"integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","shasum":"bcd1cda1a1ef8ed80581638a02cf88182d437d09","tarball":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"gitHead":"58523d6155ce5c0c6371da4ad7e0afa976743d89","greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"apertureless","email":"juszczak.j@googlemail.com"}],"module":"es/index.js","name":"vue-chartjs","optionalDependencies":{},"peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"readme":"ERROR: No README data found!","repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//

var _constants = __webpack_require__(166);

var constants = _interopRequireWildcard(_constants);

var _helpers = __webpack_require__(308);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    var _this = this;

    return {
      events: constants.EVENTS.reduce(function (eventsHandlers, event) {
        return _extends({}, eventsHandlers, _defineProperty({}, event, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this.emitEvent(event, args);
        }));
      }, {})
    };
  },


  watch: {
    options: {
      deep: true,
      handler: function handler() {
        var activeSectionIndex = $('.fp-section.active').index();
        var activeSlideIndex = $('.fp-section.active').find('.slide.active').index();

        this.destroy('all');

        $('.section').eq(activeSectionIndex).addClass('active');

        if (activeSlideIndex > -1) {
          $('.section.active').find('.slide').eq(activeSlideIndex).addClass('active');
        }

        this.init();
      }
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var isfullPage = false;
      var self = this;
      if ($(window).width() > 995 && $(window).height() > 850) {
        createfullPage();
      }

      function createfullPage() {
        if (isfullPage === false) {
          isfullPage = true;

          $(self.$el).fullpage(_extends({}, self.options, self.events));
        }
      }

      $(window).resize(function () {
        if ($(window).width() > 995 && $(window).height() > 850) {
          createfullPage();
        } else {
          if (isfullPage === true) {
            isfullPage = false;
            $.fn.fullpage.destroy('all');
          }
        }
      });
    },
    destroy: function destroy() {
      $.fn.fullpage.destroy('all');
    },
    emitEvent: function emitEvent(name, args) {
      // Emit event on Vue way
      this.$emit.apply(this, [(0, _helpers.camelToKebab)(name)].concat(_toConsumableArray(args)));

      // Run event's handler with non Vue way
      if (this.options.hasOwnProperty(name)) {
        this.options[name].apply(this, args);
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(329),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(201),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f463e6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(323),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(325),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bb7bbc7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(320),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(322),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(327),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(328),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(321),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 320:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__text"
  }, [_vm._v("\n    ABA.KG   ©2018\n  ")])])
}]}

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fetchData) ? _c('div', {
    staticClass: "content block__width-995 fullpage-container"
  }, [_c('full-page', {
    attrs: {
      "options": _vm.options
    },
    on: {
      "after-load": _vm.afterLoad
    }
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "data-menuanchor": "page1",
      "id": "section1"
    }
  }, [_c('div', {
    staticClass: "chart"
  }, [_c('div', {
    staticClass: "chart__title"
  }, [_vm._v(_vm._s(_vm.chartTitle))]), _vm._v(" "), _c('div', {
    staticClass: "chart-block"
  }, [_c('div', {
    staticClass: "chart__address"
  }, [_vm._v("\n                " + _vm._s(_vm.chartAddress) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "chart__value"
  }, [_vm._v("\n                " + _vm._s(_vm.chartValue) + "\n                "), _c('span', [_vm._v("\n                  мгм/м3\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart__interactive"
  }, [_c('div', {
    staticClass: "chart__info"
  }, [_c('div', {
    staticClass: "chart__info-top",
    style: (_vm.infoStyle)
  }, [_c('div', {
    staticClass: "chart__info-top-title"
  }, [_vm._v("\n                  " + _vm._s(_vm.infoTitle) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-top-desc"
  }, [_vm._v("\n                  " + _vm._s(_vm.infoDesc) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom"
  }, [_c('div', {
    staticClass: "chart__info-bottom-item chart__info-bottom-item1"
  }, [_c('div', {
    staticClass: "chart__info-bottom-label"
  }, [_vm._v("Температура"), _c('br'), _vm._v("C")]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom-value"
  }, [_vm._v(_vm._s(_vm.infoHumidity))])]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom-item chart__info-bottom-item2"
  }, [_c('div', {
    staticClass: "chart__info-bottom-label"
  }, [_vm._v("Влажность"), _c('br'), _vm._v("%")]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom-value"
  }, [_vm._v(_vm._s(_vm.infoTemp))])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart__diagram"
  }, [_c('div', {
    staticClass: "custom-select"
  }, [_c('div', {
    staticClass: "custom-select__item custom-select__item1",
    class: {
      customSelecActive: _vm.activeLink === 1
    },
    on: {
      "click": function($event) {
        _vm.changePeriod('day', 1)
      }
    }
  }, [_vm._v("за сутки")]), _vm._v(" "), _c('div', {
    staticClass: "custom-select__item",
    class: {
      customSelecActive: _vm.activeLink === 2
    },
    on: {
      "click": function($event) {
        _vm.changePeriod('week', 2)
      }
    }
  }, [_vm._v("за неделю")])]), _vm._v(" "), _c('line-chart', {
    staticClass: "line-chart",
    attrs: {
      "fetchData": _vm.fetchData,
      "chartPeriod": _vm.chartPeriod
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-button",
    on: {
      "click": this.moveSectionDown
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "section2",
      "data-menuanchor": "page2"
    }
  }, [_c('div', {
    staticClass: "map-desc"
  }, [_vm._v("\n          Нажмите на маркер, чтобы посмотреть данные этого датчика\n        ")]), _vm._v(" "), _c('GmapMap', {
    staticStyle: {
      "width": "100%",
      "height": "450px"
    },
    attrs: {
      "center": {
        lat: 42.874602,
        lng: 74.609141
      },
      "zoom": 13
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "icon": m.icon,
        "position": m.position,
        "clickable": true,
        "draggable": false
      },
      on: {
        "click": function($event) {
          _vm.buildMap(m.position)
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "scroll-button",
    on: {
      "click": this.moveSectionDown
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "section3",
      "data-menuanchor": "page3"
    }
  }, [_c('info', {
    attrs: {
      "fetchData": _vm.fetchData
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo header__logo"
  }, [_c('span', {
    staticClass: "header__title"
  }, [_vm._v("\n      Aba.kg\n    ")])])])
}]}

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "block__width-1200",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_loaded),
      expression: "is_loaded"
    }]
  }, [_c('sHeader'), _vm._v(" "), _c('router-view', {
    on: {
      "pageStatus": _vm.pageLoader
    }
  }), _vm._v(" "), _c('sFooter')], 1)]), _vm._v(" "), (!_vm.is_loaded) ? _c('div', {
    staticClass: "ic_loader"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(291)
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block__width-780"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ })

},[206]);


// WEBPACK FOOTER //
// static/js/app.18950c5c682ad5a33d40.js